import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import CustomButton from "../../components/CustomButton";
import GroupList from "./GroupList";

export default function Groups() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-row justify-between  gap-5">
        <PageHeader title="Groups/Houses" />
        <CustomButton
          text="Create Group"
          color="bg-primary-500"
          onClick={() => navigate("/groups-houses/add-group")}
        />
      </div>
      <GroupList />
    </div>
  );
}
